<div class="form-group" [class.has-error]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id" class="{{ labelClass }}">
      {{ props.label }}
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }

  <ng-template #fieldComponent></ng-template>

  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
